import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  const footerCategories = categories.slice(0, 8);
  const footerGuides = [
    { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
    { name: "Jackets", url: "https://kaspreadsheet.com/category-914-Jackets.html" },
    { name: "T-Shirts", url: "https://kaspreadsheet.com/category-913-T-Shirts.html" },
    { name: "Accessories", url: "https://kaspreadsheet.com/category-920-Accessories.html" },
  ];

  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-database-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-900 whitespace-nowrap">
                OOPBuy Spreadsheet
              </span>
            </div>
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
              {t("footer.brand.desc")}
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              {t("footer.categories")}
            </h4>
            <ul className="space-y-2.5">
              {footerCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              {t("footer.guides")}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/oopbuy-spreadsheet-complete-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  {t("footer.guide.link")}
                </Link>
              </li>
              {footerGuides.map((guide) => (
                <li key={guide.name}>
                  <a
                    href={guide.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {guide.name} Guide
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              {t("footer.legal")}
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">{t("footer.privacy")}</a></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">{t("footer.terms")}</a></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">{t("footer.disclaimer")}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 hover:bg-background-200 transition-colors cursor-pointer">
              <i className="ri-global-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-600 hover:bg-background-200 transition-colors cursor-pointer">
              <i className="ri-shopping-bag-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}